export default {
  tindakLanjut(state) {
    return state.tindakLanjut;
  },

  tindakLanjutById(state) {
    return state.tindakLanjutById
  },

  hasTindakLanjut(state) {
    return state.tindakLanjut && state.tindakLanjut.length > 0;
  },

  shouldUpdate(state) {
    const lastFetch = state.lastFetch;
    if (!lastFetch) {
      return true;
    }
    const currentTimeStamp = new Date().getTime();
    return (currentTimeStamp - lastFetch) / 1000 > 60;
  }
};